import hcSticky from "@/vendors/hc-sticky/hc-sticky";
import ResizeSensor from "resize-sensor";
import Helpers from "@/services/helpers";

export default {
  install(Vue) {
    let $page = null;
    let sidebarsInited = false;
    let stickySidebarLeft = null;
    let stickySidebarRight = null;

    function update() {
      if (stickySidebarLeft && stickySidebarRight) {
        setTimeout(() => {
          stickySidebarLeft.refresh();
          stickySidebarRight.refresh();
        }, 100);
      }
    }

    function init($el) {
      $page = $el;

      new ResizeSensor($page, Helpers.debounce(() => update(), 100));

      if (!sidebarsInited) {
        stickySidebarLeft = new hcSticky(".page__sidebar", {
          top: 0,
          bottom: 0,
          stickTo: ".page__left"
        });

        stickySidebarRight = new hcSticky(".page__aside", {
          top: 0,
          bottom: 0,
          stickTo: ".page__right"
        });

        sidebarsInited = true;
      }
    }

    Vue.prototype.$sidebarsInited = sidebarsInited;
    Vue.prototype.$initSidebars = init;
    Vue.prototype.$updateSidebars = update;
  }
};
